/**
 * Periodos del módulo de precios.
 *
 * Los ficheros del bot se llaman `AAAA-MM-DD_UBICACION.json`, así que el filtro
 * de histórico del panel son un año (`AAAA`) y, opcionalmente, un mes (`MM`).
 */

/** Meses del filtro de periodo (`MM` → nombre). */
export const MESES = [
  ['01', 'Enero'],
  ['02', 'Febrero'],
  ['03', 'Marzo'],
  ['04', 'Abril'],
  ['05', 'Mayo'],
  ['06', 'Junio'],
  ['07', 'Julio'],
  ['08', 'Agosto'],
  ['09', 'Septiembre'],
  ['10', 'Octubre'],
  ['11', 'Noviembre'],
  ['12', 'Diciembre'],
] as const;

/** Nombre del mes a partir de `MM` (`'10'` → `Octubre`). */
export function nombreMes(mes: string): string {
  return MESES.find(([valor]) => valor === mes)?.[1] ?? '';
}

/** `AAAA-MM-DD…` → `dd/mm/aaaa` (sólo la fecha; la hora del bot viene desplazada). */
export function fechaCorta(valor?: string): string {
  const partes = /^(\d{4})-(\d{2})-(\d{2})/.exec(String(valor || ''));

  return partes ? `${partes[3]}/${partes[2]}/${partes[1]}` : '';
}

/** `AAAA-MM-DD…` → `dd/mm` (etiquetas cortas de las gráficas). */
export function diaMes(valor: string): string {
  const partes = /^(\d{4})-(\d{2})-(\d{2})/.exec(String(valor || ''));

  return partes ? `${partes[3]}/${partes[2]}` : String(valor || '');
}

/** Tamaño legible a partir de bytes (`2,27 MB`). */
export function tamanoLegible(bytes: number): string {
  const valor = Number(bytes) || 0;

  if (valor < 1024) return `${valor} B`;
  if (valor < 1024 * 1024) return `${(valor / 1024).toFixed(2)} KB`;

  return `${(valor / (1024 * 1024)).toFixed(2)} MB`;
}
